import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Headphones } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3 className="footer-title">Kevitco Technologies</h3>
          <p className="footer-description">
            Powering IT Operations. Securing the Future.
          </p>
          <p className="footer-tagline">
            Next-generation IT services and solutions company delivering high-performance, 
            secure, and scalable technology services to global enterprises.
          </p>
        </div>

        <div className="footer-section">
          <h4 className="footer-heading">Quick Links</h4>
          <ul className="footer-links">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4 className="footer-heading">Our Services</h4>
          <ul className="footer-links">
            <li>Security Operations Center (SOC)</li>
            <li>Network Operations Center (NOC)</li>
            <li>Data Center Operations</li>
            <li>Global Product Support</li>
          </ul>
          <div className="footer-support-icon">
            <Headphones size={20} />
            <span>24x7 Global Support</span>
          </div>
        </div>

        <div className="footer-section">
          <h4 className="footer-heading">Contact Info</h4>
          <ul className="footer-contact">
            <li>
              <Mail size={18} />
              <span>info@kevitco.com</span>
            </li>
            <li>
              <MapPin size={18} />
              <span>India</span>
            </li>
          </ul>
          <p className="footer-support">24x7 Global Support</p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Kevitco Technologies. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
